export default "__VITE_ASSET__BkwypF_D__"